import { render, staticRenderFns } from "./MemberStoryCard.vue?vue&type=template&id=22a10d1c&scoped=true&"
import script from "./MemberStoryCard.vue?vue&type=script&lang=ts&"
export * from "./MemberStoryCard.vue?vue&type=script&lang=ts&"
import style0 from "./MemberStoryCard.vue?vue&type=style&index=0&id=22a10d1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a10d1c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default})
